export enum DisplayDateFormat {
  ShortMonthAndDay = 'SHORT_MONTH_AND_DAY',
  ShortMonthDayYear = 'SHORT_MONTH_DAY_YEAR',
  NumericMonthDayYear = 'NUMERIC_MONTH_DAY_YEAR',
}

export type TypeDisplayDateFormats =
  | DisplayDateFormat.ShortMonthAndDay
  | DisplayDateFormat.ShortMonthDayYear
  | DisplayDateFormat.NumericMonthDayYear;

// state value when dealing with the Freeform Date Input
export type ChildBirthDateInput = {
  year: string;
  month: string;
  day: string;
};
